import { ROUTE_IDS } from '../routes/ids.js';
import { canonicalPageRegistry as basePageRegistry } from './page-registry.js';
import { MARKET_PRICE_MANAGEMENT_PAGES } from './market-price-pages.js';
import { REPORTING_PAGES } from './reporting-pages.js';
const GOVERNED_DELEGATION_PAGE_ROUTE_IDS = new Set([
    ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_LIST,
    ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_CREATE,
    ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_DETAIL,
    ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_REVOKE,
]);
const PROMOTED_PAGE_ROUTE_IDS = new Set([
    ROUTE_IDS.REPORTS,
    ROUTE_IDS.PLATFORM_USERS_LIST,
    ROUTE_IDS.PLATFORM_USERS_CREATE,
    ROUTE_IDS.PLATFORM_USERS_DETAIL,
    ROUTE_IDS.PLATFORM_USERS_EDIT,
    ROUTE_IDS.PLATFORM_MODULES_DETAIL,
    ROUTE_IDS.PLATFORM_MODULE_ASSIGNMENTS,
    ROUTE_IDS.PLATFORM_AUDIT_LIST,
    ROUTE_IDS.PLATFORM_AUDIT_DETAIL,
    ROUTE_IDS.PLATFORM_ACCESS_INSPECTOR,
    ROUTE_IDS.DATA_CLIENTS,
    ROUTE_IDS.DATA_CLIENT_DETAIL,
    ROUTE_IDS.DATA_PORTFOLIOS,
    ROUTE_IDS.DATA_PORTFOLIO_DETAIL,
    ROUTE_IDS.DATA_CASH,
    ROUTE_IDS.DATA_JOURNALS,
    ROUTE_IDS.DATA_JOURNAL_DETAIL,
    ROUTE_IDS.DATA_FISCAL_PERIODS,
    ROUTE_IDS.DATA_MARKET_PRICES,
    ROUTE_IDS.DATA_MARKET_PRICE_DETAIL,
    ROUTE_IDS.DATA_SETTLEMENT_INSTRUCTIONS,
    ROUTE_IDS.DATA_SETTLEMENT_FAILURES,
    ROUTE_IDS.DATA_POSITION_TRANSFERS,
    ROUTE_IDS.DATA_MANAGEMENT_FEES,
    ROUTE_IDS.DATA_PERFORMANCE_FEES,
    ROUTE_IDS.ORGANIZATION_JURISDICTION_SETTINGS,
]);
const DEMOTED_PAGE_ROUTE_IDS = new Set([
    ROUTE_IDS.DATA_FX_RATES,
    ROUTE_IDS.DATA_BENCHMARKS,
    ROUTE_IDS.DATA_MARKET_DATA_PROVIDERS,
    ROUTE_IDS.DATA_MARKET_DATA_EXCEPTIONS,
    ROUTE_IDS.DATA_MANDATES,
    ROUTE_IDS.DATA_CUSTODY_BALANCES,
    ROUTE_IDS.DATA_CHART_OF_ACCOUNTS,
    ROUTE_IDS.DATA_EVIDENCE,
    ROUTE_IDS.DATA_EVIDENCE_DETAIL,
    ROUTE_IDS.DATA_TAX_CALCULATIONS,
    ROUTE_IDS.ORGANIZATION_APPROVAL_POLICIES_LIST,
    ROUTE_IDS.ORGANIZATION_APPROVAL_POLICIES_DETAIL,
    ROUTE_IDS.ORGANIZATION_PERMISSION_BUNDLES_LIST,
    ROUTE_IDS.ORGANIZATION_PERMISSION_BUNDLES_DETAIL,
    ROUTE_IDS.ORGANIZATION_RETENTION_POLICIES,
    ROUTE_IDS.ORGANIZATION_EXPORT_POLICIES,
    ROUTE_IDS.ORGANIZATION_SECURITY_SETTINGS,
    ROUTE_IDS.ORGANIZATION_REGULATORY_PROFILE,
    ROUTE_IDS.ORGANIZATION_SUPPORT_ACCESS,
    ROUTE_IDS.PLATFORM_SECURITY_POSTURE,
    ROUTE_IDS.PLATFORM_DATA_PROVIDER_HEALTH,
    ROUTE_IDS.PLATFORM_MAINTENANCE_DELEGATIONS_LIST,
    ROUTE_IDS.PLATFORM_MAINTENANCE_DELEGATIONS_CREATE,
    ROUTE_IDS.PLATFORM_MAINTENANCE_DELEGATIONS_DETAIL,
]);
const projectedBasePages = basePageRegistry.map((page) => {
    if (GOVERNED_DELEGATION_PAGE_ROUTE_IDS.has(String(page.routeId))) {
        const { disabledReasonKey: _disabledReasonKey, ...livePage } = page;
        return {
            ...livePage,
            availability: 'AVAILABLE',
            auditPolicy: 'ALWAYS',
        };
    }
    if (PROMOTED_PAGE_ROUTE_IDS.has(String(page.routeId))) {
        const { disabledReasonKey: _disabledReasonKey, ...livePage } = page;
        return {
            ...livePage,
            availability: 'AVAILABLE',
        };
    }
    if (DEMOTED_PAGE_ROUTE_IDS.has(String(page.routeId))) {
        return {
            ...page,
            availability: 'PLANNED',
        };
    }
    return page;
});
export const canonicalPageRegistry = [
    ...projectedBasePages,
    ...MARKET_PRICE_MANAGEMENT_PAGES,
    ...REPORTING_PAGES,
];
export function getPageById(pageId) {
    return canonicalPageRegistry.find((page) => page.id === pageId);
}
export function getPageByRouteId(routeId) {
    return canonicalPageRegistry.find((page) => String(page.routeId) === routeId);
}
export function getPageIds() {
    return canonicalPageRegistry.map((page) => page.id);
}
export function getRouteIdsWithPages() {
    return canonicalPageRegistry.map((page) => String(page.routeId));
}
